var __jsx = React.createElement;
import { styled } from '@linaria/react';
import React from 'react';
import { Spinner } from './Spinner';
import { jsx as _jsx } from "react/jsx-runtime";
var SpinnerContainer = /*#__PURE__*/styled("section")({
  name: "SpinnerContainer",
  class: "sdlzxfw"
});
var StyledSpinner = /*#__PURE__*/styled(Spinner)({
  name: "StyledSpinner",
  class: "s3j7bhc"
});

var FullScreenSpinner = function FullScreenSpinner() {
  return /*#__PURE__*/_jsx(SpinnerContainer, {
    "data-test-id": "loading-spinner",
    children: /*#__PURE__*/_jsx(StyledSpinner, {})
  });
};

export default FullScreenSpinner;

require("../../../apps/tv/.linaria-cache/packages/@webtv/shared-ui/FullScreenSpinner.linaria.module.css");